export default __webpack_public_path__ + "static/media/kaapi-7.eaa487f8.jpg";